"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var clsx_1 = require("clsx");
var Grid_1 = require("@material-ui/core/Grid");
var contentLineStyles_1 = require("./contentLineStyles");
var DualContent = function (_a) {
    var content = _a.content, secondaryContent = _a.secondaryContent, className = _a.className, alignment = _a.alignment, dataTest = _a.dataTest;
    var style = contentLineStyles_1.default();
    return (<Grid_1.default container={true} direction="row" justifyContent={alignment} className={className} data-test={dataTest}>
      <Grid_1.default item={true} md={7} xs={7} data-test="primary_content">
        {content}
      </Grid_1.default>
      <Grid_1.default item={true} md={5} xs={5} className={clsx_1.default(style.secondaryContent)} data-test="secondary_content">
        {secondaryContent}
      </Grid_1.default>
    </Grid_1.default>);
};
exports.default = DualContent;
